import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface WorkspaceState {
  workspaceId: string | null
  workspaceName: string | null
  plan: 'free' | 'starter' | 'growth' | 'enterprise'
  customFirebaseKey: string | null
  customFirebaseProjectId: string | null
  setWorkspace: (id: string, name: string, plan: WorkspaceState['plan']) => void
  setCustomFirebaseKey: (key: string | null, projectId: string | null) => void
  clearWorkspace: () => void
}

export const useWorkspaceStore = create<WorkspaceState>()(
  persist(
    (set) => ({
      workspaceId:   null,
      workspaceName: null,
      plan:          'free',
      customFirebaseKey: null,
      customFirebaseProjectId: null,
      setWorkspace:  (id, name, plan) => set({ workspaceId: id, workspaceName: name, plan }),
      setCustomFirebaseKey: (key, projectId) => set({ customFirebaseKey: key, customFirebaseProjectId: projectId }),
      clearWorkspace: () => set({ workspaceId: null, workspaceName: null, plan: 'free', customFirebaseKey: null, customFirebaseProjectId: null }),
    }),
    { name: 'hrx-workspace' }
  )
)
